import React from 'react';

import Default from '@common/embedded/image/Default';
import RowWrap from '@common/embedded/image/row-wrap/ImageRowWrap';

const components = [
  {
    component: Default,
    key: 'Default'
  },
  {
    component: RowWrap,
    key: 'Row - Wrap'
  }
];

const ImageEmbed = ({ data }) => {
  const { style } = data;
  const Component = components.find(x => x.key === style)?.component || Default;
  return <Component data={data}/>;
}

export default ImageEmbed
